import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  loggedInUser: {
    id: 'mfaPage.loggedInUser',
    defaultMessage: 'Kirjautunut käyttäjä:',
  },
  appCodeLabel: {
    id: 'mfaPage.appCodeLabel',
    defaultMessage: 'Sovelluksen koodi',
  },
  rememberDeviceForDays: {
    id: 'mfaPage.rememberDeviceForDays',
    defaultMessage: 'Muista tunnistautuminen {days} päivää tällä laitteella',
  },
  cancel: {
    id: 'mfaPage.cancel',
    defaultMessage: 'Peruuta',
  },
  send: {
    id: 'mfaPage.send',
    defaultMessage: 'Lähetä',
  },
  registeredPhoneNumber: {
    id: 'mfaPage.registeredPhoneNumber',
    defaultMessage: 'Rekisteröity puhelinnumero',
  },
  smsCodeLabel: {
    id: 'mfaPage.smsCodeLabel',
    defaultMessage: 'Tekstiviestin koodi',
  },
  codeSentPrefix: {
    id: 'mfaPage.codeSentPrefix',
    defaultMessage: 'Koodi lähetetty numeroon',
  },
  codeSentSuffix: {
    id: 'mfaPage.codeSentSuffix',
    defaultMessage: 'Syötä tekstiviestissä oleva kuusinumeroinen koodi alla olevaan',
  },
  codeSentFieldSuffix: {
    id: 'mfaPage.codeSentFieldSuffix',
    defaultMessage: '-kenttään. Koodi on voimassa 3 minuuttia.',
  },
  sendOneTimeCodePrefix: {
    id: 'mfaPage.sendOneTimeCodePrefix',
    defaultMessage: 'Lähetä kertakäyttöinen koodi puhelinnumeroon',
  },
  sendOneTimeCodeSuffix: {
    id: 'mfaPage.sendOneTimeCodeSuffix',
    defaultMessage: 'Koodi on voimassa 3 minuuttia.',
  },
  sendCode: {
    id: 'mfaPage.sendCode',
    defaultMessage: 'Lähetä koodi',
  },
  activateAuthenticator: {
    id: 'mfaPage.activateAuthenticator',
    defaultMessage: 'Ota autentikaattori käyttöön',
  },
  sendCodeBySms: {
    id: 'mfaPage.sendCodeBySms',
    defaultMessage: 'Lähetä koodi tekstiviestillä',
  },
  tupasRequiredPrefix: {
    id: 'mfaPage.tupasRequiredPrefix',
    defaultMessage: 'Kirjautuminen vaatii kaksivaiheisen tunnistautumisen',
  },
  webPortalLink: {
    id: 'mfaPage.webPortalLink',
    defaultMessage: 'verkkoportaalista',
  },
  tupasRequiredSuffix: {
    id: 'mfaPage.tupasRequiredSuffix',
    defaultMessage: 'Ota tunnistus käyttöön painikkeesta "2-vaiheinen tunnistus" jotta voit kirjautua sisään. Käyttöönotossa menee muutama minuutti.',
  },
  refreshView: {
    id: 'mfaPage.refreshView',
    defaultMessage: 'Päivitä näkymä',
  },
  twoFactorAuthentication: {
    id: 'mfaPage.twoFactorAuthentication',
    defaultMessage: '2-vaiheinen tunnistus',
  },
})
